export const SESSION_STORAGE_UNAVAILABLE = "unavailable";

export function isBrowser(): boolean {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

export function newUuid(): string {
  return crypto.randomUUID();
}

export function getCookie(name: string): string | null {
  if (!isBrowser()) return null;
  const prefix = `${name}=`;
  const parts = document.cookie.split(";");
  for (const part of parts) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      try {
        return decodeURIComponent(trimmed.slice(prefix.length));
      } catch {
        return trimmed.slice(prefix.length);
      }
    }
  }
  return null;
}

export function setCookie(
  name: string,
  value: string,
  maxAgeSeconds: number,
): void {
  if (!isBrowser()) return;
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    `max-age=${maxAgeSeconds}`,
    "path=/",
    "samesite=lax",
  ];
  if (window.location.protocol === "https:") {
    parts.push("secure");
  }
  document.cookie = parts.join("; ");
}

export function deleteCookie(name: string): void {
  if (!isBrowser()) return;
  document.cookie = `${name}=; max-age=0; path=/; samesite=lax`;
}

export function getSessionItem(key: string): string | null {
  if (!isBrowser()) return null;
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return SESSION_STORAGE_UNAVAILABLE;
  }
}

export function setSessionItem(key: string, value: string): void {
  if (!isBrowser()) return;
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
    // sessionStorage may be disabled; callers can still use cookie fallback.
  }
}
